module.exports = __webpack_public_path__ + "static/media/cardDefault.b8261325.jpg";